import React from 'react';

const KoiiEpoch = () => {
  return <div>Current Epoch: 233</div>; // Example output
};

export default KoiiEpoch;
